var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M18.334 3.95a1.195 1.195 0 0 1 1.692 0 1.2 1.2 0 0 1 0 1.695l-6.332 6.342 6.357 6.367a1.2 1.2 0 0 1 0 1.695 1.195 1.195 0 0 1-1.692 0l-6.357-6.367-6.358 6.367a1.195 1.195 0 0 1-1.692 0 1.2 1.2 0 0 1 0-1.695l6.358-6.367-6.333-6.342a1.2 1.2 0 0 1 0-1.694 1.195 1.195 0 0 1 1.692 0l6.333 6.341z"
  })));
};
export default SvgIconClose;